const createEstimateFromPage = {
  methods: {
    createEstimateFromPage () {
      // Send GA event
      if (this.$ga) {
        // Send GA event
        this.$gtag.event(`estimate_referral_${this.$route.name}`, {
          'event_category': 'referral',
          'event_label': this.$route.path,
          'value': 10
        })
      }
      // Change routes
      this.$router.push({ name: 'estimate' })
    }
  }
}

export { createEstimateFromPage }



// WEBPACK FOOTER //
// ./src/mixins/createEstimateFromPage.js